module.exports = __webpack_public_path__ + "img/success.029d0fe6.png";